import request from '@/utils/request'
// 账号密码登录
export function login (data) {
  return request({
    url: '/communityLogin',
    method: 'POST',
    data
  })
}
// 手机号登录
export function mobileLogin (data) {
  return request({
    url: '/loginByMobile',
    method: 'POST',
    data
  })
}
// 注册账号
export function register (data) {
  return request({
    url: '/hr/userextatt/register/mobile',
    method: 'POST',
    data
  })
}
// 重置密码
export function forgotPassword (data) {
  return request({
    url: '/sys/user/forgotPassword',
    method: 'POST',
    data
  })
}
// 获取注册验证码
export function registerCode (data) {
  return request({
    url: '/sys/sms/sendVerificationCode',
    method: 'POST',
    data
  })
}
// 获取登录验证码
export function loginCode (data) {
  return request({
    url: '/sys/sms/sendLoginVerificationCode',
    method: 'POST',
    data
  })
}
// 修改密码验证码
export function passCode (data) {
  return request({
    url: '/sys/sms/sendLoginVerificationCode',
    method: 'POST',
    data
  })
}
// 微信扫码获取token
export function scanToken (data) {
  return request({
    url: '/loginByScanQR',
    method: 'POST',
    data
  })
}